



import {Component, Vue} from 'vue-property-decorator';
import AlbumFrames from "@/components/Atoms/AlbumFrames/AlbumFrames.vue";
import AlbumTag from "@/components/Atoms/AlbumTag/AlbumTag.vue";
import {ServiceFactory} from "@/services";
import {BabyAlbumModel} from "@/share";

const BabyService = ServiceFactory.get('baby');

@Component({
  components: {
    AlbumFrames,
    AlbumTag
  }
})
export default class Album extends Vue {
  private isLoading = false
  private albums: BabyAlbumModel[] = []
  private babyId = this.$route.params.id
  private hasOverlay = true

  private created() {
    this.getAlbums()
  }

  private mounted() {
    this.hasOverlay = false
  }

  private async getAlbums(): Promise<void> {
    this.isLoading = true
    this.albums = await BabyService.getAlbums(this.babyId).catch(() => [])
    this.isLoading = false
  }
}
